<template lang='pug'>
  .pa-2.pl-5.logs-editor.text-caption.browser-warning(v-if='test.browserLogs && test.browserLogs.length')
    span.text-subtitle-1.font-weight-light Browser Warnings/Errors
    div(v-for='log in test.browserLogs') {{log.severity}}: {{log.message}}
</template>

<script>
export default {
  name: 'BionicMetricsBrowserLogs',
  props: {
    test: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
  .browser-warning {
    border-radius: 4px;
    border-left: 5px solid #FF9800;
    border-right: 1px solid #FF9800;
    border-top: 1px solid #FF9800;
    border-bottom: 1px solid #FF9800;
  }
</style>
